import axios from 'axios';
import qs from 'qs';
import { message } from 'antd';

axios.defaults.timeout = 20000; // 超时20s
axios.interceptors.response.use(
  (response) => {
    // 数据相应成功 增加一些提示
    const { message } = response.data;
    const code = response.data.code || response.data.errcode;
    if (code >= 200 && code <= 400) {
      // 正常数据
    } else if (code === 403) {
      message.error(message || '登录过期，请重新登录');
      window.location.replace('/login');
    } else if (code === 404) {
      message.error(message || '网络请求不存在');
    } else if (code) {
      message.error(message || '网络异常，请稍后再试');
    }
    return response;
  },
  (error) => {
    // https://juejin.cn/post/6844903585751236621
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
      message.error('网络连接超时');
    } else if (error.message.indexOf('404') !== -1) {
      message.error('网络请求不存在');
    } else {
      message.error('网络异常，请稍后再试');
    }
    return Promise.reject(error);
  },
);

const loop = function () { };
const apiPost = (url, headers, data, success = loop, error = loop, final = loop) => {
  axios({ method: 'post', url, headers, data })
    .then((res) => {
      if (res.data.code === 200) {
        success(res.data);
      } else {
        error(res.data);
      }
      final();
    })
    .catch(err => {
      final(err);
    })
}

export const Post = ({ url, data = {}, success, error, final }) => {
  const headers = { 'Content-Type': 'multipart/form-data' };
  // 直接传json、兼容传递文件formData
  const form_data = (data instanceof FormData) ? data : qs.stringify(data);
  apiPost(url, headers, form_data, success, error, final);
}

export const PostJson = ({ url, data = {}, success, error, final }) => {
  const headers = { 'Content-Type': 'application/json' };
  apiPost(url, headers, JSON.stringify(data), success, error, final);
}

export const PostForm = ({ url, data = {}, success, error, final }) => {
  const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
  apiPost(url, headers, qs.stringify(data), success, error, final);
}
